"use strict";

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeCookie = exports.setCookie = exports.hasCookie = void 0;
var js_cookie_1 = __importDefault(require("js-cookie"));
var envDetector_1 = require("../../build-babel/utils/envDetector");
var init_1 = require("../../build-babel/form/init");
var COOKIE_COM_DOMAIN = '.hapag-lloyd.com';
var COOKIE_CN_DOMAIN = '.hapag-lloyd.cn';
var makeCookieName = function makeCookieName(baseUrl) {
  var env = (0, envDetector_1.getEnv)(baseUrl);
  if ('prod-china' === env) {
    env = 'prod';
  }
  if ('qa-china' === env) {
    env = 'qa';
  }
  if (env) {
    return "auth_".concat(env);
  }
};
var hasCookie = function hasCookie(baseUrl) {
  var cookieName = makeCookieName(baseUrl);
  return cookieName ? js_cookie_1["default"].get(cookieName) !== undefined : false;
};
exports.hasCookie = hasCookie;
var setCookie = function setCookie(value, baseUrl) {
  var cookieName = makeCookieName(baseUrl);
  cookieName && js_cookie_1["default"].set(cookieName, value, {
    domain: (0, init_1.isChineseDomain)() ? COOKIE_CN_DOMAIN : COOKIE_COM_DOMAIN
  });
};
exports.setCookie = setCookie;
var removeCookie = function removeCookie(baseUrl) {
  var cookieName = makeCookieName(baseUrl);
  cookieName && js_cookie_1["default"].remove(cookieName, {
    domain: (0, init_1.isChineseDomain)() ? COOKIE_CN_DOMAIN : COOKIE_COM_DOMAIN
  });
};
exports.removeCookie = removeCookie;
//# sourceMappingURL=cookie.js.map